import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import { UpdateLLMProjectInput, UpdateLLMProjectMutation } from "../API";

type UpdateProjectWithNotificationsInput = UpdateLLMProjectInput & {
  lowApiCreditNotificationEmails?: string | null;
  lowApiCreditNotificationMinimumCredit?: number | null;
};
export async function updateLLMProjectAfterEdit(
  values: UpdateProjectWithNotificationsInput,
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {
  const input: UpdateProjectWithNotificationsInput = {
    id: values.id,
  };

  if (values.name !== undefined) input.name = values.name;
  if (values.status !== undefined) input.status = values.status;
  if (values.description !== undefined) input.description = values.description;
  if (values.newCustomerTokenCount !== undefined) {
    input.newCustomerTokenCount = values.newCustomerTokenCount;
  }
  if (values.cacheResponsesForSeconds !== undefined) {
    input.cacheResponsesForSeconds = values.cacheResponsesForSeconds;
  }
  if (values.promptBlacklist !== undefined) {
    input.promptBlacklist = values.promptBlacklist;
  }
  if (values.loadSheddingTier !== undefined) {
    input.loadSheddingTier = values.loadSheddingTier;
  }
  if (values.newCustomerLoadSheddingTier !== undefined) {
    input.newCustomerLoadSheddingTier = values.newCustomerLoadSheddingTier;
  }
  if (values.maintenanceMode !== undefined) {
    input.maintenanceMode = values.maintenanceMode;
  }
  if (values.maintenanceModeMessage !== undefined) {
    input.maintenanceModeMessage = values.maintenanceModeMessage;
  }
  if (values.loadBalancingMode !== undefined) {
    input.loadBalancingMode = values.loadBalancingMode;
  }
  if (values.systemInstructions !== undefined) {
    input.systemInstructions = values.systemInstructions;
  }
  if (values.mcpServerWhitelist !== undefined) {
    input.mcpServerWhitelist = values.mcpServerWhitelist;
  }
  if (
    values.usageTapUsageApiKey !== undefined &&
    values.usageTapUsageApiKey !== null
  ) {
    input.usageTapUsageApiKey = values.usageTapUsageApiKey;
  }
  if (
    values.lowApiCreditNotificationEmails !== undefined &&
    values.lowApiCreditNotificationEmails !== null
  ) {
    input.lowApiCreditNotificationEmails =
      values.lowApiCreditNotificationEmails;
  }
  if (
    values.lowApiCreditNotificationMinimumCredit !== undefined &&
    values.lowApiCreditNotificationMinimumCredit !== null
  ) {
    input.lowApiCreditNotificationMinimumCredit =
      values.lowApiCreditNotificationMinimumCredit;
  }
  if (values.newCustomerUsageTierId !== undefined) {
    input.newCustomerUsageTierId = values.newCustomerUsageTierId;
  }

  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input,
    }),
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
